import * as React from 'react';
import styled from 'styled-components';
import { BrowserQRCodeReader } from '@zxing/library';

import { Card, CircularProgress, CancelIcon, Typography } from '../material-ui';

const qrCodeReader = new BrowserQRCodeReader();

const Wrapper = styled(Card)`
	height: 36rem;
	width: 37rem;
	padding: 0.5rem;
	display: flex;
	flex-flow: row wrap;
	align-items: flex-end;
	justify-content: center;
`;

const Heading = styled(Typography)`
	width: 100%;
	height: 2rem;
	margin: 0 !important;
	text-align: center;
	text-transform: uppercase;
	color: ${(p) => p.theme.palette.action.active} !important;
`;

const LoadingWrapper = styled.div`
	position: absolute;
	width: 1005;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const CloseIcon = styled(CancelIcon).attrs({
	fontSize: 'inherit',
	color: 'disabled',
})`
	position: absolute;
	top: -0.5rem;
	left: -0.5rem;
	cursor: pointer;
	background: white;
	border-radius: 100%;
	font-size: 2rem !important;
	z-index: 1;
`;

const Display = styled.video`
	width: auto;
	height: 27rem;
	border-radius: 0.25rem;
	filter: grayscale(1);
`;

export class Scanner extends React.Component {
	state = { active: false };
	displayRef = React.createRef();

	componentDidMount = async () => {
		try {
			// get rear or only camera
			// 'Video source 1' is the name on our samsung tablets
			const devices = await qrCodeReader.getVideoInputDevices();
			if (devices.length > 0) {
				const videoDevice = devices.reduce((out, cam, i) =>
					i === 0 ||
					cam.label.includes('back') ||
					cam.label.includes('rear') ||
					cam.label.includes('Video source 1')
						? cam
						: out
				);
				qrCodeReader
					.decodeFromInputVideoDevice(videoDevice.deviceId, this.displayRef.current)
					.then(this.handleScan);
			}
		} catch (e) {
			// eslint-disable-next-line no-alert
			alert(`unexpected error ${e.message}`);
		}
	};

	componentWillUnmount = () => {
		qrCodeReader.stop();
	};

	handleScan = ({ text }) => {
		this.props.onSubmit && this.props.onSubmit(text);
	};

	render = () => (
		<Wrapper>
			<CloseIcon onClick={this.props.onClose} />
			<Heading>QR Code scannen</Heading>
			<LoadingWrapper>
				<CircularProgress />
			</LoadingWrapper>
			<Display ref={this.displayRef} />
		</Wrapper>
	);
}

let cameras = null;
export const getAvailableCameras = async () => {
	if (cameras === null) {
		cameras = (await qrCodeReader.getVideoInputDevices()) || [];
	}
	return cameras;
};



// WEBPACK FOOTER //
// ./src/components/Scanner.js